import { render, staticRenderFns } from "./DoctorFormSuccess.vue?vue&type=template&id=5253c8b9"
import script from "./DoctorFormSuccess.vue?vue&type=script&lang=js"
export * from "./DoctorFormSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports